module.exports = __webpack_public_path__ + "img/icon_service.eabd6fe9.png";